module.exports = __webpack_public_path__ + "static/media/soundRestNew.38c196e7.mp3";